import React from 'react';
import { Route } from 'react-router-dom';
import ProjectBanner from './project-banner';
import ProjectDetail from '../project-detail';
import classNames from 'classnames';

const projects = [
  {
    name: 'East Side Residence',
    tag: 'residential',
    pathname: '/projects/east-side-residence',
    images: [
      require ('../../images/east_side_10.png'),
      require ('../../images/east_side_23.jpg'),
      require ('../../images/east_side_28.jpg'),
      require ('../../images/east_side_20.png'),
      require ('../../images/east_side_24.jpg'),
      require ('../../images/east_side_6.png'),
      require ('../../images/east_side_26.jpg'),
      require ('../../images/east_side_27.jpg'),
      require ('../../images/east_side_29.jpg'),
      require ('../../images/east_side_30.jpg'),
      require ('../../images/east_side_32.jpg'),
      require ('../../images/east_side_14.png'),
      require ('../../images/east_side_18.png'),
      require ('../../images/east_side_35.jpg'),
      require ('../../images/east_side_1.png')
    ],
    primaryImageIndex: 0
  },
  {
    name: 'Upper West Side',
    tag: 'residential',
    pathname: '/projects/upper-west-side',
    images: [
      require ('../../images/upper_west_side_3.jpg'),
      require ('../../images/upper_west_side_13.jpg'),
      require ('../../images/upper_west_side_1.jpg'),
      require ('../../images/upper_west_side_4.jpg'),
      require ('../../images/upper_west_side_6.jpg'),
      require ('../../images/upper_west_side_18.jpg'),
      require ('../../images/upper_west_side_11.jpg'),
      require ('../../images/upper_west_side_8.jpg'),
      require ('../../images/upper_west_side_9.jpg'),
      require ('../../images/upper_west_side_15.jpg')
    ],
    primaryImageIndex: 5
  },
  {
    name: 'Morningside',
    tag: 'residential',
    pathname: undefined,
    images: [
    ],
    primaryImageIndex: 0
  },
  {
    name: 'Willamsburg Residence',
    tag: 'residential',
    pathname: undefined,
    images: [
    ],
    primaryImageIndex: 0
  }
]


const ProjectList = () => {
  return (
    <Route render={({location}) => {
      let activeProject = undefined;
      for (let i = 0; i < projects.length; ++i){
        if (projects [i].pathname === location.pathname) {
          activeProject = (
            <ProjectDetail
              name={projects [i].name}
              images={projects [i].images}
            />
          )
        }
      }
      let sectionClass = classNames ("project-list", {
        "inactive": activeProject !== undefined
      });
      return (
        <section className={sectionClass}>
          {projects.map((project, index) => {
            let bannerImage = project.images.length > 0 ?
              project.images[project.primaryImageIndex] :
              undefined;
            return (
              <ProjectBanner
                name={project.name}
                tag={project.tag}
                projectUrl={project.pathname}
                imgUrl={bannerImage}
                key={index}
              />
            );
          })}
          { activeProject }
        </section>
      )
    }}/>
  )
}

export default ProjectList;



// WEBPACK FOOTER //
// ./components/page-project-list/index.js